import styled, { css } from 'styled-components'

type PictureUiProps = {
  ratio?: number
  mobileRatio?: number
}

const ratioCss = (ratio: number) => css`
  display: block;
  //position: relative; Why it commented: it increases the z-index layer. In general it used to make absolute image work properly but we don't use absolute image.
  height: 0;
  overflow: visible;
  padding-bottom: ${(100 / ratio).toFixed(2)}%;
`

const noRatioCss = css`
  display: contents;
`

const PictureUi = styled.picture<PictureUiProps>`
  position: relative;
  ${p => (p.ratio ? ratioCss(p.ratio) : noRatioCss)}
  ${p =>
    p.mobileRatio &&
    css`
      ${p.theme.phone} {
        ${ratioCss(p.mobileRatio)}
      }
    `}
  ${p => p.theme.isEditorMobileMode && p.mobileRatio && ratioCss(p.mobileRatio)}
`

export default PictureUi
